'use client';

import { useEffect } from 'react';
import { registerServiceWorker, precacheMultipleEpisodes } from '@/lib/register-service-worker';
import { usePathname } from 'next/navigation';

export default function ServiceWorkerRegistration() {
  const pathname = usePathname();
  
  useEffect(() => {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      // 只注册一次Service Worker，不要在pathname变化时重复注册
      registerServiceWorker();
    }
  }, []); // 移除pathname依赖，只在组件挂载时注册一次
  
  // 单独处理episode预缓存逻辑
  useEffect(() => {
    if (pathname?.includes('/episodes/')) {
      const episodeId = pathname.split('/episodes/')[1];
      if (episodeId) {
        console.log(`Current episode: ${episodeId}`);
        // 预缓存逻辑可以在这里，但不要重新注册Service Worker
      }
    }
  }, [pathname]);


  return null; // 这个组件不渲染任何 UI
}